module.exports = __webpack_public_path__ + "img/Kbank.35c20076.svg";